import { useColorModeValue } from '@chakra-ui/react';

export const useColors = () => {
  const backgroundCardColor = useColorModeValue('white', 'whiteAlpha.100');
  const textColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const subTextColor = useColorModeValue('gray.600', 'gray.400');
  const inputBgColor = useColorModeValue('white', 'whiteAlpha.50');
  const headingBgColor = useColorModeValue('white', 'navy.800');
  const hoverBgColor = useColorModeValue('gray.50', 'whiteAlpha.50');
  const selectedBgColor = useColorModeValue('blue.50', 'blue.900');

  // Additional colors for store components
  const cardBgColor = useColorModeValue('white', 'navy.800');
  const tableBgColor = useColorModeValue('white', 'navy.800');
  const rowBorderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const inputColor = useColorModeValue('gray.800', 'whiteAlpha.900');
  const placeholderColor = useColorModeValue('gray.500', 'gray.400');
  const dividerColor = useColorModeValue('gray.300', 'whiteAlpha.300');

  // Tab colors
  const activeBgColor = useColorModeValue('blue.500', 'blue.400');
  const inactiveBgColor = useColorModeValue('gray.100', 'whiteAlpha.100');
  const activeTextColor = useColorModeValue('white', 'white');
  const inactiveTextColor = useColorModeValue('gray.600', 'gray.400');
  const hoverInactiveBgColor = useColorModeValue('gray.200', 'whiteAlpha.200');

  return {
    backgroundCardColor,
    textColor,
    borderColor,
    subTextColor,
    inputBgColor,
    headingBgColor,
    hoverBgColor,
    selectedBgColor,
    cardBgColor,
    tableBgColor,
    rowBorderColor,
    inputColor,
    placeholderColor,
    dividerColor,
    activeBgColor,
    inactiveBgColor,
    activeTextColor,
    inactiveTextColor,
    hoverInactiveBgColor,
  };
};
